import { getBaseURL } from 'service/env'
import * as service from 'service'
import axios from 'axios'

const baseURL = getBaseURL('dponet')

const create = async ({ complaintId = '', twoFactorAuthToken, ...data }) => {
  var formData = new FormData()

  data?.content && formData.append('complaint_message[content]', data?.content)
  formData.append('complaint_message[complaint_status]', data.complaintStatus)
  data?.visibility &&
    formData.append('complaint_message[visibility]', data.visibility)

  Array.from(data.attachments).map((attachment) => {
    return formData.append(`complaint_message[attachments][]`, attachment)
  })

  const config = {
    headers: {
      'Content-Type': 'multipart/form-data',
      'Content-Disposition': 'attachment',
      Authorization: service.dponet.auth.getToken(),
    },
  }

  if (twoFactorAuthToken) {
    config.headers['X-Complaints-2FA-Token'] = twoFactorAuthToken
  }

  return await axios({
    method: 'POST',
    url: `${baseURL}/complaints/${complaintId}/complaint_messages`,
    data: formData,
    ...config,
  })
}

export default { create }
